<template>
  <div
    class="avatar"
    :class="{ 'is-fallback': isFallback }"
    :style="boxStyle"
  >
    <img
      v-if="!isFallback"
      :src="src"
      @error="onError"
      class="avatar-img"
    />
    <span v-else class="avatar-char">{{ fallbackChar }}</span>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    src: String,
    char: String,          // 自定义展示文字
    size: { type: [String, Number], default: 40 },
    bgColor: { type: String, default: '#0071e3' }
  },
  data () {
    return { isFallback: false }
  },
  computed: {
    fallbackChar () {
      return this.char || (this.$attrs.alt || '').charAt(0) || 'A'
    },
    boxStyle () {
      const s = typeof this.size === 'number' ? `${this.size}px` : this.size
      return {
        width: s,
        height: s,
        backgroundColor: this.bgColor
      }
    }
  },
  watch: {
    src () { this.isFallback = false }
  },
  methods: {
    onError () { this.isFallback = true }
  }
}
</script>

<style scoped>
.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  border-radius: inherit;
}
.avatar-char {
  color: #fff;
  font-size: 50%;
  line-height: 1;
  font-weight: 500;
  text-transform: uppercase;
  user-select: none;
}
</style>